// STUB — FTMS Cross Trainer Data characteristic (0x2ACE). Spec §4.8.
//
// Phase 2: NB — Cross Trainer uses a 24-bit flags field (3 bytes), not 16-bit
// like bike/rower. Read as `view.getUint16(0, true) | (view.getUint8(2) << 16)`.
// Bit 0 inverted (More Data). Field order: Inst Speed, Avg Speed, Total
// Distance (uint24), Step Per Minute + Avg, Stride Count, Elevation Gain,
// Inclination + Ramp Angle, Resistance, Power + Avg, Expended Energy, HR,
// MET, Elapsed Time, Remaining Time, Movement Direction (uint8).

import type { CrossTrainerMetrics } from "../types";

export function parseCrossTrainerData(_view: DataView): CrossTrainerMetrics {
  return {
    type: "cross_trainer",
    power_watts: null,
    heart_rate_bpm: null,
    elapsed_time_s: null,
    remaining_time_s: null,
    speed_kmh: null,
    stride_rate_spm: null,
    total_distance_m: null,
  };
}
